<template>
  <v-list-item
    :class="{ 'p-0': noPadding }"
  >
    <template v-slot:prepend>
      <Avatar class="mr-3" :src="imageUrl" :alt="initials" />
    </template>

    <v-list-item-title class="d-flex align-center flex-wrap">
      <span class="inline-flex">{{ title }}</span>
      <span
          v-if="initialsName"
          class="pli__initials text-xs font-bold ml-4"
          :style="initialsStyle"
          v-text="initials"
      ></span>
      <span
          v-for="(doctor, index) in initialsItemDoctors"
          :key="index"
          v-if="initialsItemDoctors && initialsItemDoctors.length > 0"
          class="pli__initials text-xs font-bold ml-2"
          :style="doctorStyle(doctor)"
          :title="doctor.doctor.name"
      >{{ $filters.initials(doctor.doctor.name) }}</span>
    </v-list-item-title>

    <v-list-item-subtitle>
      {{ $dayjs(timestamp).format('hh:mm A | MMM D, YYYY') }}
    </v-list-item-subtitle>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import randomColor from 'randomcolor';
import Avatar from '@/components/basic/Avatar.vue';

export default defineComponent({
  name: 'PatientListItem',
  components: { Avatar },
  props: {
    imageUrl: { type: String, required: true },
    initialsName: { type: String, required: false },
    initialsColor: { type: String, required: false },
    initialsItemDoctors: { type: Array, required: false },
    noPadding: { type: Boolean, default: false },
    timestamp: { type: [Date, String, Object], required: true },
    title: { type: String, required: true },
  },
  computed: {
    initials() {
      return this.$filters.initials(this.initialsName ?? 'X X');
    },
    initialsStyle() {
      const backgroundColor =
        this.initialsColor ?? (this.initials === 'XX'
          ? '#E83123'
          : randomColor()
        );
      return {
        backgroundColor,
        color: this.$filters.foregroundColor(backgroundColor),
      };
    },
  },
  methods: {
    doctorStyle(doctor) {
      const backgroundColor = doctor?.doctor?.color ?? randomColor();
      return {
        backgroundColor,
        color: this.$filters.foregroundColor(backgroundColor),
      };
    },
  },
});
</script>

<style scoped>
.pli__initials {
  padding: 2px 4px;
  border-radius: 6px;
}
</style>
